// Built-in Apple system apps available for Home Screen Layout placement.
// Bundle IDs are the public, documented identifiers for stock iOS/iPadOS apps.

export interface SystemApp {
  bundleId: string;
  name: string;
  platforms: Array<"iphone" | "ipad">;
}

export const APPLE_SYSTEM_APPS: SystemApp[] = [
  { bundleId: "com.apple.mobilephone", name: "Phone", platforms: ["iphone"] },
  { bundleId: "com.apple.MobileSMS", name: "Messages", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.mobilemail", name: "Mail", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.mobilesafari", name: "Safari", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.Preferences", name: "Settings", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.mobilecal", name: "Calendar", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.mobileslideshow", name: "Photos", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.camera", name: "Camera", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.Maps", name: "Maps", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.AppStore", name: "App Store", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.Music", name: "Music", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.Health", name: "Health", platforms: ["iphone"] },
  { bundleId: "com.apple.findmy", name: "Find My", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.weather", name: "Weather", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.reminders", name: "Reminders", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.mobilenotes", name: "Notes", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.calculator", name: "Calculator", platforms: ["iphone"] },
  { bundleId: "com.apple.Passbook", name: "Wallet", platforms: ["iphone"] },
  { bundleId: "com.apple.facetime", name: "FaceTime", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.podcasts", name: "Podcasts", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.tv", name: "TV", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.iBooks", name: "Books", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.news", name: "News", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.Fitness", name: "Fitness", platforms: ["iphone"] },
  { bundleId: "com.apple.shortcuts", name: "Shortcuts", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.translate", name: "Translate", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.compass", name: "Compass", platforms: ["iphone"] },
  { bundleId: "com.apple.mobiletimer", name: "Clock", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.stocks", name: "Stocks", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.VoiceMemos", name: "Voice Memos", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.Home", name: "Home", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.freeform", name: "Freeform", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.iMovie", name: "iMovie", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.Keynote", name: "Keynote", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.Pages", name: "Pages", platforms: ["iphone", "ipad"] },
  { bundleId: "com.apple.Numbers", name: "Numbers", platforms: ["iphone", "ipad"] },
];

export function systemAppsFor(ff: "iphone" | "ipad"): SystemApp[] {
  return APPLE_SYSTEM_APPS.filter((a) => a.platforms.includes(ff));
}
